/** Base App */
import Vue from 'vue';
import App from './App.vue';
/** Store & Router */
import store from './store/store';
import router from './router';
/** App plugins */
import worldPlugin from '../../../world/spa/libs/world-plugin';
import payPlugin from '../../../pay/spa/libs/pay-plugin';
import foodPlugin from '../libs/food-plugin';
/** WebGraphics Global Plugin */
import WebGraphics from '../../../world/spa/libs/wg-global-plugin';
import '../../utilities/css/style.css';
import '../../../yourbeach/css/map.css';
/** WorldMenu Plugin */
import WorldMenu from '../../../world/spa/libs/menu-plugin';
/** WorldHeadbar Plugin */
import WorldHeadbar from '../../../world/spa/libs/headbar-plugin';
/** WGModal plugin */
import WGModal from '../../../world/spa/libs/modal-plugin';
/** Offline plugin */
import Offline from '../../../world/spa/libs/offline-plugin';
/** Auth plugin */
import Auth from '../../../world/spa/libs/auth-plugin';
/** Custom implementation of axios */
import axiosPlugin from '../libs/axios';
/** Local forage */
import localforagePlugin from '../libs/localForage';
/** Moment.js plugin to manage dates */
// import VueMoment from 'vue-moment';
import VueMoment from '../../../world/spa/libs/vue-moment-fork';
import moment from 'moment';
import 'moment/locale/it';
import momentTimezone from 'moment-timezone';
/* Top progress bar */
import VueProgressBar from 'vue-progressbar';
/* QRCode generator */
import VueQriously from 'vue-qriously';
/* Google maps */
import * as GmapVue from 'gmap-vue';
/** Service Worker */
import './registerServiceWorker';

/** Printer classes in window */
import * as printer_includes from '../../../world/libs/anm22_printers/js/printer_includes_es6';
Object.assign(window, printer_includes);

if(process.env.NODE_ENV === 'production' && process.env.VUE_APP_PRODUCTION_MODE === 'test') {
  Vue.config.devtools = true;
}

Vue.config.productionTip = false;

Vue.use(worldPlugin);
Vue.use(foodPlugin);
Vue.use(payPlugin);

Vue.use(VueQriously);

Vue.use(VueProgressBar, {
  color: '#0aabf4',
  failedColor: 'red',
  height: '2px',
  position: 'fixed'
})

// Configurazione di Vue-localforage
Vue.use(localforagePlugin);

// Axios come $http in Vue, disponibile globalmente
Vue.use(axiosPlugin);

Vue.use(VueMoment, {
  moment,
  momentTimezone
});

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyCpMdSoYSIz-AIzaSyCROLZgMtm6KHWCguvlw8Rb0Lj3YmkDlvE',
    libraries: 'places',
    language: 'it',
    region: 'IT'
  },
  installComponents: true
});
/**
 * WebGraphics
 */
Vue.use(WebGraphics, { store });

/**
 * WGModal
 */
Vue.use(WGModal, { store });

/**
 * World Menu
 */
Vue.use(WorldMenu, { store });

/**
 * Headbar World
 */
Vue.use(WorldHeadbar, { store });


/**
 * Offline plugin
 */
Vue.use(Offline, { store });

Vue.use(Auth, { store });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
